<template>
    <div class="row">
        <div class="col">
            <div class="card page-card">

                <div class="card-header d-flex align-items-center justify-content-between">
                    <div class="title">
                        <i class="fa fa-align-justify mr-2"></i>
                        {{ trans.title }}
                    </div>
                </div>

                <div class="card-block" style="min-height: calc(100vh - 140px);" v-cloak>
                    <form @submit.prevent="">
                        <div class="row justify-content-between">

                            <div class="col col-10 col-lg-9 col-xl-7 form-group compact">
                                <div class="input-group">
                                    <select class="custom-select" v-model="filters.type" @change="filterChanged('type', $event.target.value)">
                                        <option value="all">{{ trans.legal_checks_all }}</option>
                                        <option v-for="(legalCheck, index) in legalChecks" :value="index" :key="index">
                                            {{ legalCheck }}
                                        </option>
                                    </select>

                                    <div class="col mb-0 form-group">
                                        <div class="input-group">
                                            <button type="button" v-if="isFiltered()" class="btn btn-danger" @click="resetFilter(); filter()">
                                                <i class="fa fa-trash-alt"></i> <span class="hidden-sm-down">{{ trans.btn.delete_filter }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group ml-auto pr-3">
                                <dropdown-months
                                    :trans="transMonths"
                                    :year-count="5"
                                    :year="year"
                                    :month="month"
                                    :choose-action="chooseMonth"
                                    :loading="loading"
                                    :show-buttons="true"
                                />
                            </div>

                        </div>
                    </form>

                    <div class="loading-box" v-if="loading">
                        <div class="loading-inner"><i class="fa fa-spin fa-circle-notch text-secondary"></i></div>
                    </div>

                    <div class="table-responsive table-scrollable" v-if="!loading">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th></th>
                                <th column="name">{{ trans.columns.employee_name }}</th>
                                <th column="contract_type">{{ trans.columns.contract_type }}</th>
                                <th column="work_day_date">{{ trans.columns.work_day_date }}</th>
                                <th column="legal_check_type">{{ trans.columns.legal_check_type }}</th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="(item, index) in items" :key="index">
                                <td>
                                    <template v-if="item.wage_personal_number">
                                        <span :title="trans.badge.wage_personal_number" class="badge badge-light px-3 contract-type">{{ item.wage_personal_number }}</span>
                                    </template>
                                </td>
                                <td>
                                    {{ item.full_name }}
                                </td>
                                <td>{{ item.contract_type_shortcode }}</td>
                                <td>{{ item.check_date }}</td>
                                <td>{{ item.type }}</td>
                                <td>
                                    <a :href="getAttendanceDetailUrl(item.employee_contract_id)" target="_blank" :title="trans.btn.show_attendance" class="btn btn-spinner btn-primary">
                                        <i class="far fa-fw fa-clock"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>

                            <tfoot v-if="items.length === 0">
                            <tr>
                                <td colspan="6">
                                    <div class="text-center d-flex align-items-center justify-content-center" style="height: 80px;"><i>{{ trans.empty_data_msg }}</i></div>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AppListing from '../../app-components/Listing/AppListing';

    export default {
        name: 'LegalChecksReport',
        mixins: [AppListing],
        props: {
            'url': {
                type: String
            },
            'baseUrl': {
                type: String
            },
            'legalChecks': {
                type: Object,
                default() {
                    return null;
                }
            },
            'selectedMonth': {
                type: Object,
                default() {
                    return null;
                }
            },
            'trans': {
                type: Object
            },
            'transMonths': {
                type: Object
            },
        },
        data() {
            return {
                filters: {
                    type: 'all',
                },
                loading: true,
                items: [],
                selectedMonthMutable: {},
                initSetDataComplete: false,
                mutableUrl: '',
                dateUrlPath: '',
                startOfMonth: '',
                endOfMonth: '',
                year: null,
                month: null,
            };
        },

        created() {
            this.year = Number(moment(this.selectedMonth.key).format('YYYY'));
            this.month = Number(moment(this.selectedMonth.key).format('MM'));

            this.selectedMonthMutable = this.selectedMonth.key;
            this.mutableUrl = this.url;

            this.startOfMonth = moment(this.selectedMonth.key, 'YYYY-MM').startOf('month').format('YYYY-MM-01 00:00:00');
            this.endOfMonth = moment(this.selectedMonth.key, 'YYYY-MM').endOf('month').format('YYYY-MM-DD 23:59:59');

            const momentSelectedMonth = moment(this.selectedMonth.key, 'YYYY-MM');
            this.dateUrlPath = momentSelectedMonth.format('YYYY')+'/'+momentSelectedMonth.format('MM');

            this.$nextTick(function () {
                this.initSetDataComplete = true;
            });
        },

        methods: {
            chooseMonth(year, month) {
                this.selectedMonthMutable = year+'-'+(month < 10 ? '0':'')+month;

                this.year = year;
                this.month = month;

                const momentDate = moment(this.selectedMonthMutable, 'YYYY-MM');

                this.dateUrlPath = momentDate.format('YYYY/MM');
                this.startOfMonth = momentDate.startOf('month').format('YYYY-MM-01 00:00:00');
                this.endOfMonth = momentDate.endOf('month').format('YYYY-MM-DD 23:59:59');

                this.mutableUrl = this.baseUrl+'/'+this.dateUrlPath;

                this.refreshData();
            },

            refreshData() {
                if (this.initSetDataComplete) {
                    if(window.history.replaceState) {
                        window.history.replaceState({}, null, this.mutableUrl);
                    }

                    this.loadData();
                }
            },

            loadData() {
                this.loading = true;

                let data = {
                    params: {
                        type: this.filters.type
                    }
                };

                axios.get(this.mutableUrl, data)
                    .then(response => {
                        this.items = response.data;
                        this.loading = false;
                    })
                    .catch(error => {});
            },

            getAttendanceDetailUrl(employeeContractId) {
                return '/attendance-detail/'+employeeContractId+'/'+this.dateUrlPath;
            },

            filterChanged(key, value) {
                this.filters[key] = value;
                this.$emit('filter', this.filters[key]);
                this.loadData();
            },

            resetFilter() {
                this.filters.type = 'all';
                this.$emit('filter', this.filters.type);
                this.loadData();
            },

            isFiltered() {
                return this.filters.type !== 'all';
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/report/legal-checks-report/LegalChecksReport.vue